exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".insumo {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  position: relative;\n  padding: 20px; }\n\napp-acordeon-item {\n  margin-top: 10px;\n  display: block; }\n\n.composicion {\n  padding-top: 20px;\n  border-top: 1px solid #dddddd; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-detalle-insumo-page/agris-detalle-insumo-page.component.scss
// module id = ../../../../../src/app/components/agris/agris-detalle-insumo-page/agris-detalle-insumo-page.component.scss
// module chunks = 0